import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProfessionalAudience } from './components/ProfessionalAudience';
import { StatsBar } from './components/StatsBar';
import { Problems } from './components/Problems';
import { SessionMap } from './components/SessionMap';
import { Modules } from './components/Modules';
import { ModuleIncludes } from './components/ModuleIncludes';
import { Printables } from './components/Printables';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { PricingPack } from './components/PricingPack';
import { Guarantee } from './components/Guarantee';
import { CostOfNotBuying } from './components/CostOfNotBuying';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: MetaPixel;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}

// Pixel «T-R-C IT» (portfolio Eureka_labs.Italia), lo stesso del checkout di Impultienda.
// Non riutilizzare mai quello di un'altra offerta (Reiki IT, Costellazioni IT).
const META_PIXEL_ID = '1603009877679110';
export function App() {
  useEffect(() => {
    if (!META_PIXEL_ID) return;
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }

    // Stessa coda del codice ufficiale di Meta: fbevents.js riprende le chiamate con callMethod.
    const fbq: MetaPixel = (...args: unknown[]) => {
      if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue?.push(args);
    };
    fbq.push = fbq;
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/it_IT/fbevents.js';
    document.head.appendChild(script);
    fbq('init', META_PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <main className="w-full overflow-x-hidden bg-mist font-sans text-navy antialiased" data-id="element-0" data-mp="3udkr489qbgg7">
      <Hero data-id="element-1" data-mp="d57dixer88gf" />
      <ProfessionalAudience data-id="element-2" data-mp="d3mkjc838xko" />
      <StatsBar data-id="element-3" data-mp="d3wbp34vdary" />
      <Problems data-id="element-4" data-mp="d2bjhk6123x9" />
      <SessionMap data-id="element-5" data-mp="85uj9rljzz3t" />
      <Modules data-id="element-6" data-mp="85bap1hsmn2g" />
      <ModuleIncludes data-id="element-7" data-mp="86w6eufugc1w" />
      <Printables data-id="element-8" data-mp="86cld4uwd7jn" />
      <Comparison data-id="element-9" data-mp="83qivjmv5i8a" />
      <Bonuses data-id="element-10" data-mp="3gl4pnbwh7qhe" />
      <PricingPack data-id="element-11" data-mp="3gklc07duzo96" />
      <Guarantee data-id="element-12" data-mp="3gm61hilbgh06" />
      <CostOfNotBuying data-id="element-13" data-mp="3glo2ie79rook" />
      <FAQ data-id="element-14" data-mp="3bmbf9schkflg" />
      <FinalCTA data-id="element-15" data-mp="3bmjo995hn0rd" />
      <Footer data-id="element-16" data-mp="3bn2zy84joswy" />
    </main>;
}